import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import { OPT_IN_CONTENT_BLOCKER } from "../../types";
import { HTML_ATTRIBUTE_COOKIE_IDS } from "./manipulateDom";
/**
 * Listen to clicked content blockers and automatically delegate the click
 * event to the underlying element. This is especially useful for overlays of videos
 * so the user does not need to click twice.
 */

function delegateClickThroughUnblockedContent() {
  document.addEventListener(OPT_IN_CONTENT_BLOCKER, /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var _ref$detail, element, gotClicked, delegateClick, nextElementSibling, parentElement, parentElementNextSibling, fn;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _ref$detail = _ref.detail, element = _ref$detail.element, gotClicked = _ref$detail.gotClicked;

              if (gotClicked) {
                nextElementSibling = element.nextElementSibling;
                parentElement = element.parentElement;
                parentElementNextSibling = parentElement.nextElementSibling; // JetElements for Element

                if (element.matches("iframe.jet-video-iframe") && nextElementSibling !== null && nextElementSibling !== void 0 && nextElementSibling.matches(".jet-video__overlay")) {
                  delegateClick = nextElementSibling;
                } // Divi Page Builder


                if (parentElement.matches(".et_pb_video_box") && parentElementNextSibling.matches(".et_pb_video_overlay")) {
                  delegateClick = parentElementNextSibling;
                } // We delegate the click to an element, let's check if it is also blocked and listen to unblock


                if (delegateClick) {
                  fn = function fn() {
                    return delegateClick.click();
                  };

                  if (delegateClick.hasAttribute(HTML_ATTRIBUTE_COOKIE_IDS)) {
                    delegateClick.addEventListener(OPT_IN_CONTENT_BLOCKER, fn, {
                      once: true
                    });
                  } else {
                    fn();
                  }
                }
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
}

export { delegateClickThroughUnblockedContent };